import React from 'react'
import { DisplayIconProps } from '../DisplayIcon.d'

const CallSupport = ({ classes, inverse, color }: DisplayIconProps) => {
  let strokeFill = color ? color : '#5069C3'
  let accentColor = color ? color : '#FF4C00'
  if (inverse) {
    strokeFill = '#7A7A7A'
    accentColor = '#FFF'
  }

  return (
    <svg
      className={classes}
      data-testid='DisplayIcon-CallSupport'
      fill='none'
      height='64'
      viewBox='0 0 64 64'
      width='64'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M50 43V44C50 44 51 54 44 54H41'
        data-testid='DisplayIcon-CallSupport-accentColor'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M37.25 49.5H26.75C24.6789 49.5 23 51.1789 23 53.25C23 55.3211 24.6789 57 26.75 57H37.25C39.3211 57 41 55.3211 41 53.25C41 51.1789 39.3211 49.5 37.25 49.5Z'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M14 26V22C14 15.08 20.75 7 32 7C43.25 7 50 15.08 50 22V26'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M15.25 43C11.52 43 7 42.7 7 37V32C7 27.5 11.52 26 15.25 26V43Z'
        data-testid='DisplayIcon-CallSupport-strokeFill'
        stroke={strokeFill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M48 26C51.73 26 57 26.3 57 32V37C57 41.5 51.73 43 48 43V26Z'
        stroke={strokeFill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
    </svg>
  )
}

export default CallSupport
